<template lang="pug">
  v-container.fill-height.align-center.justify-center.pa-0(max-width="600px")
    v-card(flat width="950px" class="rounded-card mx-auto" d-flex justify-center)
      v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
        template( v-slot:action="{attrs}")
          v-btn(text v-bind="attrs"
            @click="snackBar = false") {{ $t('buttons.closeButtonLabel') }}
      AddNewGroupDialog(
        v-if="showNewGroupDialog"
        :show="showNewGroupDialog"
        :loading="loading"
        @saved="onCreateNewGroup"
        @close="onCloseNewGroupDialog")
      GroupSortingDialog(
        v-if="showSortGroupDialog"
        :show="showSortGroupDialog"
        :menuGroupItem="menuGroupList"
        :loading="loading"
        @close="onCloseSortGroupDialog"
        @updateMenuGroupOrder="onUpdateMenuGroupOrder")
      MenuGroupDetail(
        :show="showGroupDetailDialog"
        v-if="showGroupDetailDialog"
        :selectedTopGroup="selectedTopGroup"
        :loading="loading"
        :closeDialog="closeDialog"
        @saveTopGroupName="saveTopGroupName"
        @saveSubGroup="saveSubGroup"
        @close="onCloseGroupDetailDialog"
        @saveSlot="onSaveSlot"
        @fetchData="fetchGroupData"
        @saveUpdatedSlot="saveUpdatedSlot"
        )
      v-container.pa-0( v-if="!fetchInProgress" v-resize="onResize")
        v-row.ma-0.align-self-start
          v-card-text(ref="title")
            v-row.ma-0.align-self-start
            v-select(
                outlined
                v-model="selectedBusiness"
                append-icon="fas fa-chevron-down" item-value="id" item-text="name" return-object
                :items="businessData" :label="$t('settingsPage.offerStructure.business')"
                @change="onBusinessChange"
            )
        v-row.ma-0.mt-0(v-if="$vuetify.breakpoint.mdAndUp")
          v-toolbar.elevation-0
            v-row.ma-0.align-self-start
              v-col.text-center.pr-0(cols="3")
                v-fab-transition
                  v-btn(@click="addGroup" color="primary" :disabled="!selectedBusiness")
                    v-icon.pr-4 fas fa-plus
                    span {{ $t('settingsPage.offerStructure.addNewGroup') }}
              v-col.text-start.pl-0(cols="9")
                v-fab-transition
                  v-btn(@click="sortGroup" :disabled="!selectedBusiness")
                    v-icon.pr-4 fas fa-bars
                    span {{ $t('settingsPage.offerStructure.sortingGroup') }}

        v-card.align-self-start(v-if="selectedBusiness && $vuetify.breakpoint.mdAndUp" flat)
          v-card-text.overflow-auto(style="position: relative" :style="cardHeight")
            v-row.ma-0.align-self-start
              v-col(cols="7")
                v-list(v-for="(menuGroupItem, idx) in  menuGroupList" :key="idx")
                  v-list-item(@click="showGroupDetailDialogClick(menuGroupItem)")
                    v-list-item-icon
                      v-icon(small) fas fa-utensils
                    v-list-item-title.textColor {{menuGroupItem.title}}
                  v-list-item.ml-15(@click="showGroupDetailDialogClick(item)" v-for="(item, idx) in  menuGroupItem.subMenuGroups" :key="idx")
                    v-list-item-title {{item.title}}


        v-card.align-self-start(v-if="selectedBusiness && $vuetify.breakpoint.smAndDown")
          v-card-text.overflow-auto(style="position: relative" :style="cardHeight")
            v-row.ma-0.align-self-start
              v-col(cols="7")
                v-list(v-for="(menuGroupItem, idx) in  menuGroupList" :key="idx")
                  v-list-item(@click="showGroupDetailDialogClick(menuGroupItem)")
                    v-list-item-icon
                      v-icon(small) fas fa-utensils
                    v-list-item-title.textColor {{menuGroupItem.title}}
                  v-list-item.ml-14(@click="showGroupDetailDialogClick(item)" v-for="(item, idx) in  menuGroupItem.subGroupCollection" :key="idx")
                    v-list-item-title {{item.title}}
          v-fab-transition
            v-btn.sortMobileGroupButton(@click="sortGroup" color="success" small dark right absolute fab)
              v-icon fa-solid fa-bars
          v-fab-transition
            v-btn.addMobileGroupButton(@click="addGroup" color="pink" medium dark right absolute fab)
              v-icon fas fa-plus

      v-skeleton-loader( v-if="fetchInProgress"
        type="list-item@12"
        width="100%")
      
</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import _ from 'lodash'
import MenuGroupSlotEditor from '@/components/settings/MenuGroupSlotEditor.vue'
import {Action} from 'vuex-class'
import {
  CREATE_NEW_SLOT,
  FETCH_BUSINESS_DATA,
  FETCH_DAILY_MENU,
  FETCH_MENU_GROUP_DATA,
  SAVE_NEW_GROUP,
  SAVE_UPDATED_GROUP
} from '@/store/action-types'
import MenuOffer from '@/model/dailymenu/MenuOffer'
import AddNewGroupDialog from "@/components/settings/AddNewGroupDialog.vue";
import GroupSortingDialog from "@/components/settings/GroupSortingDialog.vue";
import MenuGroupDetail from "@/components/settings/MenuGroupDetail.vue";
import MenuGroupList from "@/model/menu/MenuGroupList";
import BusinessModel from "@/model/menu/BusinessModel";
import {NewGroupPayload, NewSlotPayload, SlotPayload, TopGroupPayload} from "@/types/payload";
import {SlotCollectionResponse, SubGroupCollectionResponse} from "@/types/service-response";
import Tag from "@/model/tennant/Tag";

@Component({
  components: {
    MenuGroupSlotEditor,
    AddNewGroupDialog,
    GroupSortingDialog,
    MenuGroupDetail
  }
})
export default class OfferStructureTab extends Vue {
  private menuGroupList: MenuGroupList[] = []
  private selectedTopGroup: MenuGroupList | null = null

  private fetchInProgress: boolean = false
  private snackBar: boolean = false
  private snackBarMessage: string = ''
  private snackBarColor: string = ''
  private businessData: BusinessModel[] = []
  private selectedBusiness: BusinessModel | null = null
  private showNewGroupDialog: boolean = false
  private showSortGroupDialog: boolean = false
  private showGroupDetailDialog: boolean = false
  private loading: boolean = false
  private cardHeight: string = ''
  private business: any | null = null
  private closeDialog: boolean = false

  @Action(FETCH_DAILY_MENU) fetchMenuStructure!: ({ (payload: { from: string, to: string }): Promise<MenuOffer> })
  @Action(FETCH_BUSINESS_DATA) fetchBusinessData!: ({ (): Promise<BusinessModel[]> })
  @Action(SAVE_NEW_GROUP) saveNewGroup!: ({ (payload: NewGroupPayload): Promise<MenuGroupList> })
  @Action(FETCH_MENU_GROUP_DATA) fetchMenuGroupData!: ({ (payload: any): Promise<MenuGroupList[]> })
  @Action(SAVE_UPDATED_GROUP) saveUpdatedGroup!: ({ (payload: any): Promise<any> })
  @Action(CREATE_NEW_SLOT) createNewSlot!: ({ (payload: NewSlotPayload): Promise<void> })

  $refs!: {
    title: HTMLElement

  }

  onResize () {

    if(this.$vuetify.breakpoint.mdAndUp && this.$refs.title) {
      const vh = window.innerHeight
      const titleHeight = this.$refs.title.scrollHeight
      this.cardHeight = `height: calc(${vh}px - 314px - ${titleHeight}px)`
    } else if(this.$vuetify.breakpoint.smAndDown && this.$refs.title) {
      const vh = window.innerHeight
      if(vh < 500) {
        this.cardHeight = `height:200px`
      }else {
        const titleHeight = this.$refs.title.scrollHeight
        this.cardHeight = `height: calc(${vh}px - 250px - ${titleHeight}px )`
      }
    }
  }

  onBusinessChange(item: any) {
    this.business = item.id
    this.fetchGroupData()
  }

  onCloseNewGroupDialog (): void {
    this.showNewGroupDialog = false
  }

  showGroupDetailDialogClick (item:MenuGroupList): void {
    this.selectedTopGroup = item
    this.showGroupDetailDialog = true
  }

  onCloseGroupDetailDialog (): void {
    this.showGroupDetailDialog = false
  }

  sortGroup (): void {
    this.showSortGroupDialog = true
  }

  onCloseSortGroupDialog (): void {
    this.showSortGroupDialog = false
  }

  addGroup (): void {
    this.showNewGroupDialog = true
  }

   async onUpdateMenuGroupOrder (menuGroupList: MenuGroupList[]): Promise<void> {
    let promiseList: Promise<void>[] = []
     menuGroupList.forEach((item: MenuGroupList) => {
      let subGroupCollection = item.subMenuGroups.map((i: SubGroupCollectionResponse) => {
        return `/api/menu-group/${i.id}`
      })

      let slotCollection = item.menuGroupSlots.map((i: SlotCollectionResponse) => {
        return `/api/food-ordering/menu-group-slot/${i.id}`
      })

      const payload: TopGroupPayload = {
        id: item.id,
        data: {
          title: item.title,
          order: item.order,
          subMenuGroups: subGroupCollection,
          menuGroupSlots: slotCollection
        }
      }
      promiseList.push(this.onSaveUpdatedGroup(payload))
    })

     await Promise.all(promiseList)
     await this.fetchGroupData()
  }

  onCreateNewGroup (item: string) {
      const groupOrder: number = this.menuGroupList.length > 0 ? _.maxBy(this.menuGroupList, 'order')!.order : 0
      const payload: NewGroupPayload = {
        title: item,
        order: groupOrder + 1,
        business: this.selectedBusiness!.id,
        tags: []
      }
      try {
        this.onSaveNewGroupClick(payload).then(()=> this.fetchGroupData())
      } catch (e) {
        this.snackBar = true
        this.snackBarMessage = this.$t('settingsPage.offerStructure.snackbarErrorSaveMessage').toString()
        this.snackBarColor = 'error'
      }


  }

  saveTopGroupName (item: string,selections: Tag[]) {
    if(this.selectedTopGroup) {

      let subGroupCollection = this.selectedTopGroup.subMenuGroups.map((i: SubGroupCollectionResponse) => {
        return `/api/menu-group/${i.id}`
      })

      let slotCollection = this.selectedTopGroup.menuGroupSlots.map((i: SlotCollectionResponse) => {
        return `/api/menu-group-slot/${i.id}`
      })

      let tagCollection = selections.map((i: Tag) => {
        return `/api/tag/${i.id}`
      })

      const payload: any = {
        id: this.selectedTopGroup.id,
        data: {
          title: item,
          order: this.selectedTopGroup.order,
          subMenuGroups: subGroupCollection,
          //menuGroupSlots: slotCollection,
          tags: tagCollection
        }
      }
      this.onSaveUpdatedGroup(payload).then(() => this.fetchGroupData())
    }
  }

  saveSubGroup (item: string) {
    const subGroupOrder: number = this.selectedTopGroup!.subMenuGroups.length > 0 ? _.maxBy(this.selectedTopGroup!.subMenuGroups, 'order')!.order : 0
    const payload: NewGroupPayload = {
      title: item,
      order: subGroupOrder + 1,
      business: this.selectedBusiness!.id,
      tags: []
    }

    this.onSaveNewGroupClick(payload).then((i: MenuGroupList | undefined) => {
      if(this.selectedTopGroup && i) {
        let subGroupCollection = this.selectedTopGroup.subMenuGroups.map((i: SubGroupCollectionResponse) => {
          return `/api/menu-group/${i.id}`
        })

        subGroupCollection.push(`/api/menu-group/${i.id}`)

        /*let slotCollection = this.selectedTopGroup.menuGroupSlots.map((i: SlotCollectionResponse) => {
          return `/api/food-ordering/menu-group-slot/${i.id}`
        })*/

        const payload: any = {
          id: this.selectedTopGroup.id,
          data: {
            title: this.selectedTopGroup.title,
            order: this.selectedTopGroup.order,
            subMenuGroups: subGroupCollection,
            //menuGroupSlots: slotCollection
          }
        }

        this.onSaveUpdatedGroup(payload).then(() => this.fetchGroupData().then(() => {
          if(this.selectedTopGroup && this.selectedTopGroup.isTopMenuGroup) {
            const foundItem: MenuGroupList | undefined = this.menuGroupList.find((i: MenuGroupList) => i.id === this.selectedTopGroup!.id)
            this.selectedTopGroup = foundItem ? foundItem : null
          }
        })
        )
      }
    })
  }

  async onSaveSlot (item: SlotPayload): Promise<void> {
    this.loading = true
    const slotOrder: number = this.selectedTopGroup!.menuGroupSlots.length > 0  ? _.maxBy(this.selectedTopGroup!.menuGroupSlots, 'order')!.order : 0
    const payload: NewSlotPayload = {
      title: item.title,
      order: slotOrder + 1,
      code: item.code,
      menuGroup: this.selectedTopGroup!.id,
      referencePrice: item.referencePrice ? item.referencePrice : null,
      tags: []
    }
    try {
      await this.createNewSlot(payload)
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.saved').toString()
      this.snackBarColor = 'success'
      this.closeDialog = true
      this.fetchGroupData().then(() => {
        if(this.selectedTopGroup && this.selectedTopGroup.isTopMenuGroup) {
          const foundItem: MenuGroupList | undefined = this.menuGroupList.find((i: MenuGroupList) => i.id === this.selectedTopGroup!.id)
          this.selectedTopGroup = foundItem ? foundItem : null
        } else if(this.selectedTopGroup && !this.selectedTopGroup.isTopMenuGroup) {
          let foundItem: any | undefined = undefined
          this.menuGroupList.forEach((i: MenuGroupList) => {
            const found: any | undefined = i.subMenuGroups.find((a: any) => a.id === this.selectedTopGroup!.id)
            if(found) {
              foundItem = found
            }
          })
          this.selectedTopGroup = foundItem ? foundItem : null
        }
      })


    } catch (e) {
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.snackbarErrorSaveMessage').toString()
      this.snackBarColor = 'error'

    } finally {
      this.loading = false

    }
  }

  saveUpdatedSlot () {
    this.fetchGroupData().then(() => {
      if(this.selectedTopGroup && this.selectedTopGroup.isTopMenuGroup) {
        const foundItem: MenuGroupList | undefined = this.menuGroupList.find((i: MenuGroupList) => i.id === this.selectedTopGroup!.id)
        this.selectedTopGroup = foundItem ? foundItem : null
      } else if(this.selectedTopGroup && !this.selectedTopGroup.isTopMenuGroup) {
        let foundItem: any | undefined = undefined
        this.menuGroupList.forEach((i: MenuGroupList) => {
          const found: any | undefined = i.subMenuGroups.find((a: any) => a.id === this.selectedTopGroup!.id)
          if(found) {
            foundItem = found
          }
        })
        this.selectedTopGroup = foundItem ? foundItem : null
      }
    })
  }

  async onSaveUpdatedGroup (payload: any) {
    this.loading = true
    try {
      const response: MenuGroupList = await this.saveUpdatedGroup(payload)
      this.showSortGroupDialog = false
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.saved').toString()
      this.snackBarColor = 'success'

    } catch (e) {
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.snackbarErrorSaveMessage').toString()
      this.snackBarColor = 'error'

    } finally {
      this.loading = false
    }
  }

  async onSaveNewGroupClick (payload: NewGroupPayload): Promise<MenuGroupList | undefined> {
    this.loading = true
    try {
      const response: MenuGroupList = await this.saveNewGroup(payload)
      this.showNewGroupDialog = false
      if(this.selectedTopGroup) {
        return response
      }
    } catch (e) {
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.snackbarErrorSaveMessage').toString()
      this.snackBarColor = 'error'
    } finally {
      this.loading = false
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.offerStructure.saved').toString()
      this.snackBarColor = 'success'
    }
  }

  async fetchData (): Promise<void> {
    try{
      this.fetchInProgress = true
      this.businessData = await this.fetchBusinessData()
      if(this.businessData.length === 1) {
        this.selectedBusiness = this.businessData[0]
      }

      this.fetchInProgress = false

    } catch (e) {
      this.snackBar = true
      this.snackBarMessage = this.$t('settingsPage.snackbarErrorMessage').toString()
      this.snackBarColor = 'error'
    }
  }
  
  async fetchGroupData (): Promise<void> {
    if(this.businessData && this.selectedBusiness) {
      try {
        this.menuGroupList = await this.fetchMenuGroupData(this.selectedBusiness.id.toString())
        /*let subGroupIdList: any[] = []
        this.menuGroupList.forEach((item: MenuGroupList) => {
          subGroupIdList = subGroupIdList.concat(item.subMenuGroups)
        })
        //this.menuGroupList = _.first(offer.menuList)!.menuGroupList

        subGroupIdList = subGroupIdList.map((item: MenuGroupList) => item.id)
        this.menuGroupList = this.menuGroupList.filter((item: MenuGroupList) => !subGroupIdList.includes(item.id)).map((i: MenuGroupList) => {
          i.isTopMenuGroup = true
          return i
        })*/
      } catch (e) {
      } finally {
      }
    }

  }

  async mounted(): Promise<void> {
    await this.fetchData()
    await this.fetchGroupData()
  }

  updated () {
    this.onResize()
  }
}
</script>

<style lang="stylus" scoped>
.addGroupButton {
  bottom: 20px;
  margin-right: 18px
}
.sortGroupButton {
  bottom: 20px;
  margin-bottom: 80px
  margin-right: 55px
}

.sortMobileGroupButton {
  bottom: 20px;
  margin-bottom: 80px
  margin-right: 25px
}

.addMobileGroupButton {
  bottom: 20px;
  margin-right: 18px
}

.textColor {
  color blue
}
</style>
